
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_FAMILIES = 'SET_FAMILIES';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_PRODUCT_IMAGES = 'SET_PRODUCT_IMAGES';
export const SET_CONTENTS = 'SET_CONTENTS';
